import React from 'react';
import HeaderTable from '../headerTable/headerTable';
import NoDataMessage from '../noDataMessage/noDataMessage';

/**
 * Componente especializado para mostrar tabla de ranking de golf
 * Renderiza el ranking de jugadores con posición, nombre y puntos
 * Limita la visualización a los primeros 25 jugadores
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.dataTab1 - Datos del ranking de golf
 * @param {Object} props.dataTab1.golfStages - Objeto con datos del torneo
 * @param {Array} props.dataTab1.golfStages.ranking - Array de jugadores
 * 
 * @returns {JSX.Element} Tabla de ranking de golf optimizada
 */
export default function TableGolf({ dataTab1 }) {
  const golfData = dataTab1?.golfStages || {};
  const ranking = Array.isArray(golfData.ranking) ? golfData.ranking : [];
  
  // Filtrar y validar jugadores, limitar a 25
  const validPlayers = ranking
    .filter(player => player && typeof player.position === 'number' && player.position > 0)
    .slice(0, 25);

  if (validPlayers.length === 0) {
    return <NoDataMessage title="Ranking de Jugadores" />;
  }

  const getPositionChangeClass = (position, lastPosition) => {
    if (!lastPosition || position === lastPosition) return null;
    return position < lastPosition ? 'position-up' : 'position-down';
  };

  const getNationalityClass = (nationality) => {
    return nationality?.length === 3 ? `bandera-${nationality}` : 'bandera-default';
  };

  return (
    <>
      <div className="positions-table__header">
        <HeaderTable title="Ranking de Jugadores" />
      </div>

      <div className="positions-table__sport">
        {validPlayers.length > 0 ? (
          <table className="positions-table">
            <thead>
              <tr>
                <th>POS.</th>
                <th>NOMBRE</th>
                <th>PTS</th>
              </tr>
            </thead>
            <tbody>
              {validPlayers.map((player, index) => {
                const changeClass = getPositionChangeClass(player.position, player.lastPosition);
                const nationalityClass = getNationalityClass(player.nationality);
                
                return (
                  <tr key={player.playerId || `player-${index}`}>
                    <td className="position-item">
                      <span className="position-number">{player.position}</span>
                      {changeClass && <div className={`position-change ${changeClass}`} />}
                    </td>
                    <td className="player-item">
                      <div className="player-info">
                        {player.nationality && <div className={`bandera-sport ${nationalityClass}`}></div>}
                        <span className="player-name">{player.matchName || 'Nombre no disponible'}</span>
                      </div>
                    </td>
                    <td className="points-item">
                      <span className="points-value">
                        {typeof player.points === 'number' ? player.points.toLocaleString() : '-'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="no-data">No hay datos de ranking disponibles</div>
        )}
      </div>
    </>
  );
}